import './CustomCsPcInput.css'; 

interface CustomInputProps {
  value: any;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  label: string;
  percentage: number;
  borderColor?: string;
  borderWidth?: string;
  backgroundColor?: string;
  readOnly?: boolean;
  disabled?: boolean;
}


const CustomCsPcInput: React.FC<CustomInputProps> = ({
  value,
  onChange,
  label,
  percentage,
  borderColor = "#d9d9d9",
  borderWidth = "1px",
  backgroundColor = "#ffffff",
  readOnly = false,
  disabled = false,
}) => {
  const ratio = percentage / 100;

  const containerStyle: React.CSSProperties = {
    position: "relative",
    width: `${85 * ratio}px`,
    height: `${38 * ratio}px`,
  };

  const inputStyle: React.CSSProperties = {
    height: "100%",
    width: "100%",
    borderRadius: `${8 * ratio}px`,
    border: `${borderWidth} solid ${borderColor}`,
    backgroundColor:`${disabled ? "#f5f5f5" : backgroundColor}`,
    paddingLeft: `${11 * ratio}px`,
    paddingRight: `${30 * ratio}px`,
    fontSize: `${14 * ratio}px`,
    boxSizing: "border-box",
  };

  const labelStyle: React.CSSProperties = {
    position: "absolute",
    right: `${11 * ratio}px`,
    fontSize: `${14 * ratio}px`,
    top: "50%",
    transform: "translateY(-50%)",
    pointerEvents: "none",
    color: "#909090",
  };

  return (
    <div className="input-container" style={containerStyle}>
      <input
        className="cs-pc-input"
        style={inputStyle}
        value={value}
        onChange={onChange}
        readOnly={readOnly}
        disabled={disabled}
      />
      <span className="cs-pc-label" style={labelStyle}>
        {label}
      </span>
    </div>
  );
};


export default CustomCsPcInput;
